import { render } from "./LaborInformation.vue?vue&type=template&id=f9a0738e&scoped=true"
import script from "./LaborInformation.vue?vue&type=script&lang=js"
export * from "./LaborInformation.vue?vue&type=script&lang=js"

import "./LaborInformation.vue?vue&type=style&index=0&id=f9a0738e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a0738e"]])

export default __exports__